import styled from "@emotion/styled";
var StyledSvg = /*#__PURE__*/ styled("svg", {
    target: "em8334i0"
})("display:block;");
export { StyledSvg };
